import T from 'prop-types'
import React from 'react'
import ListInput from './ListInput'
import {
  validateHash,
  HASH_TYPES_TO_EXPECTED_LENGTH
} from 'pw-validators'

const ALLOWED_TYPES = Object.keys(HASH_TYPES_TO_EXPECTED_LENGTH)

export default class FileHashListInput extends React.Component {
  static displayName = 'FileHashListInput'

  static propTypes = {
    className: T.string,
    hashType: T.oneOf(ALLOWED_TYPES),
    initialValue: T.string,
    onChange: T.func,
    allowDuplicates: T.bool
  }

  componentDidUpdate(prevProps) {
    if (prevProps.hashType !== this.props.hashType) {
      // Must force revalidation
      if (this._listInputRef) {
        this._listInputRef.triggerChange()
      }
    }
  }

  validate = (val) => {
    const {
      hashType
    } = this.props
    return validateHash(val, hashType || null)
  }

  resetToInitialValue = () => {
    if (this._editor) {
      this._editor.resetToInitialValue()
    }
  }

  _handleListInputRef = (el) => {
    if (el) {
      this._listInputRef = el
    }
  }

  render() {
    const {
      hashType
    } = this.props

    return (
      <ListInput
        lineClassName={ `file_hash_list_item` }
        lineValidator={ this.validate }
        placeholder={ `${ hashType ? hashType : "MD5, SHA1, SHA256, or SHA512" } hash` }
        ref={ this._handleListInputRef }
        { ...this.props }
      />
    )
  }
}
